<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">{{itemList.mainComplainNumber}}</div>
        </div>
        <div class="complaintObject border_bottom">
          <div class="left">被投诉对象</div>
          <div class="right">{{itemList.defendantName}}</div>
        </div>
        <div class="complaintClassification border_bottom">
          <div class="left">投诉分类</div>
          <div class="right" @click="showBox(0)">
            <span v-show="!classify">请选择 ></span>
            <span class="complaintTarget_class" v-show="classify">{{classify.name}}</span>
          </div>
        </div>
        <div class="objectofcomplaint border_bottom">
          <div class="left">被投诉对象</div>
          <div class="right" @click="showBox1(1)">
            <span v-show="!objectlist">请选择 ></span>
            <span class="complaintTarget_class" v-show="objectlist">{{objectlist.name}}</span>
          </div>
        </div>
        <div class="complaint border_bottom">
          <div class="left">投诉问题</div>
          <div class="right" @click="showBox2(2)">
            <span v-show="!one">请选择 ></span>
            <span class="complaintTarget_class" v-show="one">{{one.name}}</span>
          </div>
        </div>
        <div class="specificSituation border_bottom">
          <div class="left">具体情形</div>
          <div class="right" @click="showBox3(3)">
            <span v-show="!two">请选择 ></span>
            <span class="complaintTarget_class" v-show="two">{{two.name}}</span>
          </div>
        </div>
        <div class="specificSituation border_bottom">
          <div class="left">行政部门</div>
          <div class="right" @click="showActionSheet4">
            <span v-show="selectList.length===0">请选择 ></span>
            <span v-show="selectList.length>0" style="color:#000">已选择({{selectList.length}}/{{proList.length}})</span>
            <!-- <span class="complaintTarget_class" v-show="situation">{{situation}}</span> -->
          </div>
        </div>
        <div class="whetherApplyAplitting border_bottom" v-if="is_split==='0'">
          <div class="left">是否申请拆单</div>
          <div class="right">
            <van-RadioGroup
              v-model="isSplit"
              style="display:flex;margin-top:15px;justify-content:space-around"
            >
              <van-Radio name="1">是</van-Radio>
              <van-Radio name="2">否</van-Radio>
            </van-RadioGroup>
          </div>
        </div>
        <div class="whetherToSue border_bottom">
          <div class="left">是否诉转案</div>
          <div class="right">
            <van-RadioGroup
              v-model="isCase"
              style="display:flex;margin-top:15px;justify-content:space-around"
            >
              <van-Radio name="1">是</van-Radio>
              <van-Radio name="0">否</van-Radio>
            </van-RadioGroup>
          </div>
        </div>
      </div>
      <div class="remark border_bottom" v-show="isSplit==='1'">
        <div class="titleName">申请拆单原因</div>
        <div class="notAccepted">
          <van-field placeholder="请填写申请拆单原因..." type="textarea" maxlength="50" v-model="splitReason" />
        </div>
      </div>
      <div class="companyName border_bottom" v-if="chananlType.complainChannel != 10" @click="searchCity">
           <span style="color:#aaa" v-if="selectCommand.length===0">请输入企业名称</span>
           <span style="color:#000" v-if="selectCommand.length>0">{{selectCommand[0].fullName}}</span>
      </div>
      <div class="emergencyLevel border_bottom">
        <van-field value="添加办结时限、紧急程度、工单分类" left-icon="contact" disabled />
      </div>
      <div class="urgent">
        <div class="limitedProcesseTime border_bottom">
          <div class="left">办结时限</div>
          <div class="right">
            <van-field type="number" maxlength="2" input-align="center" style="width:40px" v-model="hour" />
            <span>小时</span>
            <van-field type="number" maxlength="2" input-align="center" style="width:40px"  v-model="minite" />
            <span>分钟</span>
          </div>
        </div>
        <div class="emergencyLabel border_bottom">
          <div class="left">紧急程度</div>
          <div class="right">
            <div class="general" :class="{tabColor:limitIndex===7}" @click="general(7)">一般</div>
            <div class="heavier" :class="{tabColor1:limitIndex===8}" @click="general(8)">较重</div>
            <div class="serious" :class="{tabColor2:limitIndex===9}" @click="general(9)">严重</div>
          </div>
        </div>
        <div class="complaintClass">
          <div class="left">工单分类</div>
          <div class="right">
            <!-- <div class="Complaint" :class="{tabColor:Complaints===true}" @click="Complaint">投诉</div>
            <div class="Suggest" :class="{tabColor:Suggests===true}" @click="Suggest">建议</div> -->
            <div class="Complaint" :class="{tabColor:SuggestIndex==5}" @click="Complaint(5)">投诉</div>
            <div class="Suggest" :class="{tabColor:SuggestIndex===6}" @click="Complaint(6)">建议</div>
            <div style="width:50px;height:0;"></div>
          </div>
        </div>
      </div>
      <div class="btn">
        <div class="submit">
          <van-button type="primary"  @click="send" >确认</van-button>
        </div>
        <div class="back" @click="$router.go(-1)">
          <van-button plain type="default" color="#979595">返回</van-button>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="isshowBox1" :actions="actions" @select="onSelect" title="请选择"/>
    <van-action-sheet v-model="isshowBox2" :actions="actions1" @select="onSelect" title="请选择"/>
    <van-action-sheet v-model="isshowBox3" :actions="actions2" @select="onSelect" title="请选择"/>
    <van-action-sheet v-model="isshowBox4" :actions="actions3" @select="onSelect" title="请选择"/>
    <scroll-box :proList="proList" ref="showBox" @getSelect="getSelect"></scroll-box>
  </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    import scrollBox from './scrollType'
    import util from '../../../../utils/common'
    export default {
        components: {
            'scroll-box': scrollBox
        },
        data () {
            return {
                is_split: this.$router.currentRoute.query.is_split,
                radio: '1',
                radio1: '1',
                tab: ['一般', '较重', '严重'],
                generals: true,
                heaviers: false,
                seriouss: false,
                Complaints: true,
                Suggests: false,
                parms: {
                    complainType: 'levels',
                    pid: 0
                },
                complaintTarget: '', // 投诉分

                splitReason: '', // 申请拆单原因
                hour: '24', // 最大时长
                minite: '0', // 最大分钟
                emergency: '', // 紧急程度标签
                category: '', // 投诉分类
                regionCode: '', // 区域id
                isshowBox1: false,
                isshowBox2: false,
                isshowBox3: false,
                isshowBox4: false,
                actions: [],
                actions1: [],
                actions2: [],
                actions3: [],
                limitIndex: 7,
                SuggestIndex: 5,
                proList: [],
                selectList: [],
                selectIndex: 0,
                classify: '',
                objectlist: '',
                one: '',
                two: '',
                pid: 0,
                isSplit: '2', // 是否申请拆单
                isCase: '0', // 是否诉转案
                selectCommand: this.$store.state.complaint.selectCommand,
                userInfo: this.$store.state.complaint.userInfo || util.getJsonLocal('userInfoComplaint'),
                chananlType: '',
                isback: this.$store.state.complaint.isBackDetail || util.getJsonLocal('isBack'),
                itemList: util.getJsonLocal('item'),
                implementationDuration:0,
                flag: false
                // isShowBtn: false
            };
        },
        created () {
            // this.initDate();
            // this.getType();
            // this.getList();
        },
        activated () {
            this.is_split = this.$router.currentRoute.query.is_split;
            this.selectCommand = this.$store.state.complaint.selectCommand;
            this.chananlType = this.$store.state.complaint.basicImformation;
            this.$refs.showBox.hideBox();
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if (from.path === '/complaint/detailList/complaintSheet' || from.path === '/complaint/detailList/writeInfo' ||
                    from.path === '/complaint/detailList/saveInfo' || from.path === '/complaint/detailList/phoneHistory' || from.path === '/complaint/detailList/timeLine') {
                    vm.initDate();
                    vm.getType();
                    vm.getList();
                    vm.getIntelligentClassify();
                    vm.is_split = vm.$router.currentRoute.query.is_split;
                    // this.is_split = this.$router.currentRoute.query.is_split;
                }
            })
        },
        watch: {
            radio1 (val) {
                this.complaintTarget = val.name;
            },
            isSplit (val) {
                if (val === '2') {
                    this.isCaseFlag = false
                } if (val === '1') {
                    this.isCaseFlag = true
                }
            },
            hour (val) {
                if (val < 0) {
                    this.hour = 0
                }
                if (val > 23) {
                    this.hour = 23
                }
                if (val > 24) {
                    this.minite = 0
                }
            },
            minite (val) {
                if (val < 0) {
                    this.minite = 0
                }
                if (val > 59) {
                    this.minite = 59
                }
            }

        },
        methods: {
            initDate () {
                this.itemList = util.getJsonLocal('item');
                this.selectCommand = [];
                this.actions = [];
                this.actions1 = [];
                this.actions2 = [];
                this.actions3 = [];
                this.limitIndex = 7;
                this.SuggestIndex = 5;
                this.proList = [];
                this.selectList = [];
                this.selectIndex = 0;
                this.classify = '';
                this.objectlist = '';
                this.one = '';
                this.two = '';
                this.pid = 0;
                this.isSplit = '2'; // 是否申请拆单
                this.isCase = '0'; // 是否诉转案
            },
            getList () {
                api.worker.getDepartment({}).then((res) => {
                    if (res.ret === 0) {
                        const arr = [];
                        if (res.data.list.length > 0) {
                            res.data.list.map((item, index) => {
                                const obj = Object.assign({}, item, { 'select': false });
                                arr.push(obj);
                            })
                            this.proList = arr;
                        }
                    }
                })
            },
            Complaint (value) {
                this.SuggestIndex = value;
            },
            general (value) {
                this.limitIndex = value;
            },
            getSelect (value) {
                this.selectList = value;
                // this.$route.meta.title = '分发';
                // console.log('router', this.$route)
            },
            searchCity () {
                this.$router.push('/complaint/select');
            },
            onSelect (item) {
                console.log(item);
                if (this.selectIndex === 0) {
                    this.pid = item.id;
                    this.typeText = item.name;
                    this.isshowBox1 = false;
                    this.actions1 = [];
                    this.actions2 = [];
                    this.actions3 = [];
                    this.objectlist = '';
                    this.one = '';
                    this.two = '';
                    this.classify = item
                    this.getType1();
                } else if (this.selectIndex === 1) {
                    this.personType = item.name;
                    this.pid = item.id;
                    this.isshowBox2 = false;
                    this.actions2 = [];
                    this.actions3 = [];
                    this.one = '';
                    this.two = '';
                    this.objectlist = item
                    this.getType2();
                } else if (this.selectIndex === 2) {
                    this.qustionType = item.name;
                    this.pid = item.id;
                    console.log('pid'+this.pid);
                    this.isshowBox3 = false;
                    this.actions3 = [];
                    this.two = '';
                    this.one = item
                    this.getType3();
                } else if (this.selectIndex === 3) {
                    this.aboutType = item.name;
                    this.isshowBox4 = false;
                    this.two = item
                }
            },
            getRegion () {
                api.hordeptmentList({ Code: this.regionCode }).then(res => {
                    console.log(1000, res)
                })
            },
            heavier () {
                this.generals = false;
                this.heaviers = true;
                this.seriouss = false;
                this.emergency = 8
            },
            serious () {
                this.generals = false;
                this.heaviers = false;
                this.seriouss = true;
                this.emergency = 9
            },
            Suggest () {
                this.Complaints = false;
                this.Suggests = true;
                this.category = 6
            },
            showActionSheet1 () {
                this.show1 = true;
            },
            showActionSheet2 () {
                this.show2 = true;
            },
            showActionSheet3 () {
                this.show3 = true;
            },
            showActionSheet4 () {
                this.$refs.showBox.showBox();
            },
            showBox (index) {
                this.selectIndex = index;
                this.isshowBox1 = true;
            },
            showBox1 (index) {
                console.log(this.actions1);
                this.selectIndex = index;

                if (!this.classify) {
                    this.$Toast('请先选择投诉分类');
                } else {
                    this.isshowBox2 = true;
                }
            },
            showBox2 (index) {
                this.selectIndex = index;
                if (!this.classify) {
                    this.$Toast('请先选择投诉分类');
                } else if (!this.objectlist) {
                    this.$Toast('请先选择被投诉对象');
                } else {
                    this.isshowBox3 = true;
                }
            },
            showBox3 (index) {
                this.selectIndex = index;
                if (!this.classify) {
                    this.$Toast('请先选择投诉分类');
                } else if (!this.objectlist) {
                    this.$Toast('请先选择被投诉对象');
                } else if (!this.one) {
                    this.$Toast('请先选择投诉问题');
                } else {
                    this.isshowBox4 = true;
                }
            },
            getType () { // 获取投诉分类
                let params={
                  data:{
                    'pid':'0'
                  }
                }
                api.worker.queryDataAT(params).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            let arr=[];
                            res.data.list.map(item=>{
                              arr.push({'name':item.label,'id':item.value})
                            })
                            this.actions = arr;
                        }
                    }
                })
            },
            getType1 (pid) { // 获取分类
                let params={
                  data:{
                    'pid': pid? pid : this.pid
                  }
                }
                api.worker.queryDataAT(params).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            let arr=[];
                            res.data.list.map(item=>{
                              arr.push({'name':item.label,'id':item.value})
                            })
                            this.actions1 = arr;
                            // this.actions1 = res.data.objArrays;
                        }
                    }
                })
            },
            getType2 (pid) { // 获取分类
                let params={
                  data:{
                    'pid': pid? pid : this.pid
                  }
                }
                api.worker.queryDataAT(params).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                          let arr=[];
                          res.data.list.map(item=>{
                            arr.push({'name':item.label,'id':item.value})
                          })
                          this.actions2 = arr;
                            // this.actions2 = res.data.objArrays;
                        }
                    }
                })
            },
            getType3 () { // 获取分类
                let params={
                  data:{
                    'pid':this.pid
                  }
                }
                api.worker.queryDataAT(params).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            let arr=[];
                            res.data.list.map(item=>{
                              arr.push({'name':item.label,'id':item.value})
                            })
                            this.actions3 =arr;
                        }
                    }
                })
            },
            getIntelligentClassify() {
                let params = {
                  mainComplainNumber: this.itemList.mainComplainNumber,
                }
                api.worker.getIntelligentClassify(params).then((res) => {
                    if (res.ret === 0) {
                      let obj = {'name':res.data.label,'id':res.data.value};
                      let obj1 = {'name':res.data.child.label,'id':res.data.child.value};
                      console.log('obj', obj);
                      console.log('obj1', obj1);

                      if (obj.name && obj.id) {
                        this.classify = obj;
                        this.getType1(obj.id);
                      } else {
                        this.$Toast('请选择正确的分类');
                      }

                      if (obj1.name && obj1.id) {
                        this.objectlist = obj1;
                        this.getType2(obj1.id);
                      } else {
                        this.$Toast('请选择正确的分类');
                      }
                    }
                })
            },
            send () {
              // this.isShowBtn = true;
                if (this.classify === '') {
                    this.$Toast('请先选择投诉分类');
                } else if (this.objectlist === '') {
                    this.$Toast('请先选择被投诉对象');
                } else if (this.one === '') {
                    this.$Toast('请先选择投诉问题');
                } else if (this.two === '') {
                    this.$Toast('请先选择具体情形');
                } else if (this.selectList.length === 0) {
                    this.$Toast('请选择告知部门');
                } else {
                    const depIds = [];
                    const companyArray = [];
                    if (this.selectCommand.length > 0) {
                        companyArray[0] = this.selectCommand[0].id
                    } else {
                        companyArray[0] = ''
                    }
                    this.selectList.map((item, index) => {
                        depIds[index] = item.id;
                    })
                    this.implementationDuration=Number(this.hour)*60*60+Number(this.minite)*60;
                    console.log('implementationDuration'+ this.implementationDuration);
                    const data = {
                        mainComplainNumber: this.itemList.mainComplainNumber,
                        complainNumber: this.itemList.complainNumber,
                        subId: this.itemList.subId,
                        subPid: this.itemList.subPid,
                        complainClassify: this.classify.id,
                        complainObject: this.objectlist.id,
                        complainProblem: this.one.id,
                        specificSituation: this.two.id,
                        isSplit: this.isSplit,
                        isCase: this.isCase,
                        orderType: this.SuggestIndex,
                        emergency: this.limitIndex,
                        splitReason: this.splitReason,
                        implementationDuration:this.implementationDuration,
                        type: 'dispense',
                        enterpriseIds: companyArray[0],
                        depIds,
                    }
                    if (this.flag === false) {
                      this.flag = true;
                      api.worker.dispense(data).then((res) => {
                          console.log(res);
                          if (res.ret === 0) {
                              this.$Toast('操作成功');
                              this.$router.back();
                              // this.isShowBtn = false;
                          }else{
                              this.$Toast(ret.msg);
                          }
                      })
                    }
                }

                // api.accept(data).then((res) => {
                //     console.log(res);
                // })
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .complaintObject,
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation,
      .informAdministration,
      .whetherApplyAplitting,
      .whetherToSue {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0px;
            border-bottom: 1px solid #eee;
        .left {
          // float: left;
          width: 40%;
          font-size: 14px;
          text-align: left;
          color: #aaa;
          line-height: 1.3rem;

        }
        .right {
          // float: left;
          font-size: 14px;
          width: 60%;
          text-align: right;
        }
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation,
      .informAdministration {
        .right {
          color: #ddd;
        }
      }
      .complaintTarget_class {
        color: #000000;
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .notAccepted {
        margin-top: 14px;
        .van-cell {
          font-size: 12px;
          background: #efeded;
          border-radius: 7px;
        }
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .urgent {
      width: 100%;
      font-size: 14px;
      .limitedProcesseTime {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 40%;
          color: #aaa;
        }
        .right {
          width: 55%;
          margin-left: 15px;
          display: flex;
          .van-field {
            border-bottom: 1px solid #ccc;
            height: 30px;
            margin-top: 10px;
            padding: 0;
          }
          span {
            color: #aaa;
          }
        }
      }
      .emergencyLabel,
      .complaintClass {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 40%;
          color: #aaa;
        }
        .right {
          display: flex;
          width: 50%;
          justify-content: space-between;
          div {
            width: 50px;
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            text-align: center;
            background-color: #fff;
            color: #aaa;
          }
          .tabColor {
            background-color: #07c160;
            color: #fff;
          }
          .tabColor1 {
            background-color: #E6611E;
            color: #fff;
          }
          .tabColor2 {
            background-color: red;
            color: #fff;
          }
        }
      }
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 100%;
        border-radius: 7px;
        margin-top: 10px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
